import { Component, OnInit, HostListener, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import {
  CardValidationService,
  CardValidationDetails,
} from "./../../services/card-validation.service";
import { ConfigService } from "./../../services/config.service";
// import { GoogleAnalyticsService } from "src/app/services/google-analytics.service";
import { LoginResponse, UserService } from "./../../services/user.service";
import { SpinnerService } from "../spinner/spinner.service";
import { Subscription } from "rxjs";

@Component({
  selector: "gca-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginSub: Subscription;
  isSSOReadySub: Subscription;

  cardValidationDetails: CardValidationDetails;
  errorMessage: string;

  isCardActivationError: boolean;
  isLoading = false;
  isLogout: boolean;

  // /**
  //  * Handle message event from child iframes
  //  * @param event
  //  */
  // @HostListener("window:message", ["$event"])
  // onWindowMessage(event) {
  //   if (event.origin === this.iframeOrigin) {
  //     this.handleGotUserData(event);
  //   }
  // }

  constructor(
    private configService: ConfigService,
    // private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cardValidationService: CardValidationService,
    private spinnerService: SpinnerService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.cardValidationDetails =
      this.cardValidationService.cardValidationDetails;

    this.loginSub = this.userService.loginChanged$.subscribe((isChanged) => {
      if (this.userService.sso.isLogin) {
        this.cardValidationService.memberId = +this.userService.user.memberId;
        this.activateGiftCard();
      }
    });

    // this.isSSOReadySub = this.userService.ssoReady$.subscribe((isReady) => {
    //   if (isReady) {
    //     if (this.cardValidationDetails) {
    //       this.userService.openLoginModal(location.origin);
    //     } else {
    //       this.router.navigate(["/card-activation"]);
    //     }
    //   }
    // });
  }

  // private getEventData(messageEvent: MessageEvent): LoginResponse | string {
  //   try {
  //     return JSON.parse(messageEvent.data);
  //   } catch (e) {
  //     return messageEvent.data;
  //   }
  // }

  // private handleGotUserData(messageEvent: MessageEvent): void {
  //   this.spinnerService.showSpinner({ text: "Login process…" });
  //   const eventData = this.getEventData(messageEvent);

  //   if (typeof eventData === "string") {
  //     // eventData is token
  //     this.userService.setCurrentUser(<LoginResponse>{ token: eventData });
  //     this.userService.getCurrentUserByToken(eventData).subscribe(
  //       (response) => {
  //         this.spinnerService.hideSpinner();
  //         this.userService.setCurrentUser(response);
  //         this.cardValidationService.memberId = +response.memberId;
  //         this.activateGiftCard();
  //       },
  //       (error) => {
  //         if (error.status === 401) {
  //           this.isLogout = true;
  //         }
  //         this.spinnerService.hideSpinner();
  //         this.errorMessage = error.Message
  //           ? error.Message
  //           : "Something went wrong...";
  //       }
  //     );
  //   } else {
  //     this.userService.setCurrentUser(eventData);
  //     this.cardValidationService.memberId = +eventData.memberId;
  //     this.spinnerService.hideSpinner();
  //     this.activateGiftCard();
  //   }
  // }

  private activateGiftCard(): void {
    this.spinnerService.showSpinner({
      text: "Card activation being processed…",
    });
    this.cardValidationService.activateCard().subscribe(
      (res) => {
        this.spinnerService.hideSpinner();
        if (res.Result === 0) {
          this.errorMessage = res.ResultMessage;
          this.isCardActivationError = true;
        } else {
          // this.googleAnalyticsService.gtagReportEvent(
          //   "Activation",
          //   "GC Activation",
          //   "Activate"
          // );
          localStorage.setItem(
            "countryId",
            this.userService.currentUser.shippingAddress.countryId.toString()
          );
          this.router.navigate(["/thanks"]);
        }
      },
      (error) => {
        this.spinnerService.hideSpinner();
        this.errorMessage = error.Message
          ? error.Message
          : "Something went wrong...";
      }
    );
  }

  ngOnDestroy(): void {
    this.loginSub.unsubscribe();
    this.isSSOReadySub.unsubscribe();
  }
}
